import React, { useEffect, useRef, useState } from "react";
import {
	EExtraDataMappingType,
	ILineItemForUI,
	IMappingExtraData,
	ITupleOutputForUI,
} from "../../../../shared/common/EstimateEngine/EstimateEngineTypes";
import { logDebug, logError, logErrorNoStack } from "../../../../shared/common/logger";
import { getEstimaticsCurrentProjectStore, getUserStore } from "../../../../data/DataStores";
import { arrayUnion, collection, CollectionReference, doc, setDoc } from "firebase/firestore";
import { useFirestore, useFirestoreCollectionData } from "reactfire";
import SharedUtils, { noop } from "../../../../shared/common/SharedUtils";
import { getProcessedEstimatesStore, getProcessedEstimatesStoreDebug } from "../../../../data/ProcessedEstimatesStore";
import { observer } from "mobx-react";
import { appFeatures } from "../../../../shared/common/AppFeatures";
import RestAPI from "../../../../utils/restAPI";
import { EQuantityTypesLow } from "../../../../shared/common/interfaces";
import EngineUtils from "../../../../shared/common/EngineUtils";

import ImageCropping, { ImageCanvas } from "../../../../components/ui/utils/ImageCropping";
import EngineSharedUtils, { IQuantityFormula } from "../../../../shared/common/EstimateEngine/EngineSharedUtils";
import { toastNotify } from "../../../../shared/client/FrontendUtils";
import { setTime } from "react-datepicker/dist/date_utils";

import { LassoSimpleButton, LassoSimpleButtonFull } from "../../../../components/ui/utils/LassoButtons";
import { errorTextFromTuple, getLikelyComplementTuples } from "../ErrorResolutionPanel";
import { getMeasurementByTupleId } from "./LineEditingDialog";
import { debuglog } from "util";

const EstimateTableRowDataCell: React.FC<{ text: string }> = ({ text }) => {
	return (
		<div className="w-40 self-stretch pl-1.5 justify-start items-center flex">
			<div className="w-[90px] flex-col justify-start items-start gap-0.5 inline-flex">
				<div className="self-stretch h-10 flex-col justify-start items-start gap-1.5 flex">
					<div className="self-stretch px-3.5 py-2.5 rounded-lg justify-start items-center gap-2 inline-flex">
						<div className="grow shrink basis-0 h-5 justify-start items-center gap-2 flex">
							<div className="text-[#0f1728] text-sm font-normal font-['Hanken Grotesk'] leading-tight">{text}</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};
async function cleanAllNoteText(metaDataId: string) {
	const currentEstimateStore = getEstimaticsCurrentProjectStore();
	try {
		const firestore = getUserStore().getFirestoreInstance();
		const docRef = doc(firestore, `devLineItemsForQA/${currentEstimateStore.currentEstimateID}/lineItems`, metaDataId);
		await setDoc(
			docRef,
			{
				notes: [],
			},
			{ merge: true },
		);
	} catch (err) {
		logErrorNoStack("error saving add note text", err);
	}
}

async function saveQACheckboxValue(
	metaDataId: string,
	looksLikeABug: boolean,
	mappingError: boolean,
	approved: boolean,
	lineItem: ILineItemForUI,
) {
	const currentEstimateStore = getEstimaticsCurrentProjectStore();
	try {
		const firestore = getUserStore().getFirestoreInstance();
		const docRef = doc(firestore, `devLineItemsForQA/${currentEstimateStore.currentEstimateID}/lineItems`, metaDataId);
		await setDoc(
			docRef,
			{
				looksLikeABug: {
					looksLikeABug,
					lineItem,
				},
				mappingError: {
					mappingError,
					lineItem,
				},
				approved: {
					approved,
					lineItem,
				},
			},
			{ merge: true },
		);
	} catch (err) {
		logErrorNoStack("error saving add note text", err);
	}
}

// async function saveMappingError(metaDataId: string, mappingError: boolean, lineItem: ILineItemForUI) {
// 	const currentEstimateStore = getEstimaticsCurrentProjectStore();
// 	try {
// 		const firestore = getUserStore().getFirestoreInstance();
// 		const docRef = doc(firestore, `devLineItemsForQA/${currentEstimateStore.currentEstimateID}/lineItems`, metaDataId);
// 		await setDoc(docRef, {
// 			mappingError: {
// 				mappingError,
// 				lineItem
// 			}
// 		}, { merge: true });
// 	} catch (err) {
// 		logErrorNoStack('error saving add note text', err);
// 	}
// }

// async function saveApproved(metaDataId: string, approved: boolean, lineItem: ILineItemForUI) {
// 	const currentEstimateStore = getEstimaticsCurrentProjectStore();
// 	try {
// 		const firestore = getUserStore().getFirestoreInstance();
// 		const docRef = doc(firestore, `devLineItemsForQA/${currentEstimateStore.currentEstimateID}/lineItems`, metaDataId);
// 		await setDoc(docRef, {
// 			approved: {
// 				approved,
// 				lineItem
// 			}
// 		}, { merge: true });
// 	} catch (err) {
// 		logErrorNoStack('error saving add note text', err);
// 	}
// }

async function saveAddNoteText(metaDataId: string, addNoteText: string, lineItem: ILineItemForUI, overrideData: any = null) {
	const currentEstimateStore = getEstimaticsCurrentProjectStore();
	let yourName = window.localStorage.getItem("yourName");
	if (!yourName) {
		yourName = prompt("Please enter your name");
		if (yourName) {
			window.localStorage.setItem("yourName", yourName);
		} else {
			return;
		}
	}
	function getFormattedDate() {
		const now = new Date();

		const day = now.getDate();
		const month = now.getMonth() + 1; // Months are zero-indexed
		const hours = now.getHours();
		const minutes = now.getMinutes().toString().padStart(2, "0"); // Ensure two digits for minutes

		return `${day}/${month}-${hours}:${minutes}`;
	}
	try {
		const firestore = getUserStore().getFirestoreInstance();
		const docRef = doc(firestore, `devLineItemsForQA/${currentEstimateStore.currentEstimateID}/lineItems`, metaDataId);
		await setDoc(
			docRef,
			{
				notes: overrideData
					? overrideData
					: arrayUnion({
							lineItem,
							note: addNoteText,
							date: getFormattedDate(),
							name: yourName,
					  }),
			},
			{ merge: true },
		);
	} catch (err) {
		logErrorNoStack("error saving add note text", err);
	}
}

const EstimateTableRowElement: React.FC<{
	disableScroll?: boolean;
	editable?: boolean;
	onClick?: () => void;
	text: string;
	cls: string;
	tid?: string;
	onContentChange?: (data: IQuantityFormula) => void;
	visualElement?: React.ReactNode;
	textComponent?: React.ReactNode;
}> = ({ disableScroll, onContentChange, tid, text, cls, onClick, editable, visualElement, textComponent }) => {
	const [initialText, setInitialText] = useState(text);
	const [editableContent, setEditableContent] = useState(text);
	const [showEdit, setShowEdit] = useState(false);
	const inputRef = useRef<HTMLInputElement>(null);
	function verifyQuantity(editableContent: string) {
		let formula = EngineSharedUtils.extractFormulaFromString(editableContent);
		// logDebug("initialText", initialText);
		if (!formula) {
			setEditableContent(initialText);
			toastNotify("Bad measurament value", true);
		} else {
			const errorText = EngineSharedUtils.checkAndFixFormula(formula, getMeasurementByTupleId(tid!).toLowerCase());
			if (errorText) {
				setEditableContent(initialText);
				toastNotify(errorText, true);
			} else {
				setInitialText(EngineSharedUtils.getFormulaString(formula));
				setEditableContent(EngineSharedUtils.getFormulaString(formula));
				onContentChange && onContentChange(formula);
			}
		}
		setShowEdit(false);
		return;
		// logDebug("verifyQuantity", editableContent, data);
		// try {
		// 	const verifiedValue = EngineUtils.verifyQuantity(editableContent);
		// 	if (verifiedValue.number && verifiedValue.text) {
		// 		if (verifiedValue.number < 0) {
		// 			setEditableContent(`${verifiedValue.text}${verifiedValue.number}`);
		// 		} else {
		// 			setEditableContent(`${verifiedValue.number} ${verifiedValue.text}`);
		// 		}
		// 	} else if (verifiedValue.number && !verifiedValue.text) {
		// 		verifiedValue.text = getMeasurementByTupleId(tid!).toLowerCase();
		// 		setEditableContent(`${verifiedValue.number} ${verifiedValue.text}`);
		// 	}
		// 	onContentChange && onContentChange(verifiedValue);
		// } catch (err: any) {
		// 	setEditableContent(initialText);
		// 	toastNotify(err.message, true);
		// }
		// setShowEdit(false);
	}
	// logDebug("initialText", initialText);
	return (
		<div className={`${cls} self-stretch pl-1.5 justify-start items-center flex ${disableScroll && "overflow-hidden"}`}>
			<div className="grow shrink basis-0 flex-col justify-start items-start gap-0.5 inline-flex">
				<div className="self-stretch h-10 flex-col justify-start items-start gap-1.5 flex ">
					<div className="self-stretch px-3.5 py-2.5 rounded-lg justify-start items-center gap-2 inline-flex">
						{visualElement ?? visualElement}
						<div className="grow shrink basis-0 h-5 justify-start items-center gap-2 flex ">
							{textComponent != null ? (
								textComponent
							) : showEdit ? (
								<input
									className={`text-sm font-normal font-['Hanken Grotesk'] leading-tight p-1 w-full ${
										["N/A", "na", "Free Form Text Flag!"].includes(editableContent) ? "text-red-500" : ""
									}`}
									onKeyDown={(e) => {
										if (e.key === "Enter") {
											verifyQuantity(editableContent);
										}
									}}
									onBlur={() => {
										// logDebug("initialText", initialText);
										verifyQuantity(editableContent);
									}}
									onChange={(e) => setEditableContent(e.target.value)}
									onClick={(e) => {
										e.preventDefault();
										e.stopPropagation();
									}}
									type="text"
									ref={inputRef}
									value={editableContent}
								/>
							) : (
								<div
									className={`text-sm font-normal font-['Hanken Grotesk'] leading-tight ${
										editable ? "hover:border-2 p-1 pr-2 btn" : ""
									} ${
										["N/A", "na", "Free Form Text Flag!", "Free Text Identified: Please Edit!"].includes(
											editableContent,
										)
											? "text-red-500"
											: ""
									}`}
									onClick={(e) => {
										if (editable) {
											e.preventDefault();
											e.stopPropagation();
											setShowEdit(true);
											setTimeout(() => {
												inputRef.current?.focus();
												inputRef.current?.select();
											}, 10);
										} else {
											if (onClick) {
												onClick();
											}
										}
									}}
								>
									{editableContent}
								</div>
							)}
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

export function getMappingExtraDataContent(mappingExtraData: IMappingExtraData[], errorsOnly = false) {
	if (!appFeatures.shouldShowEngineDebugInfo(getUserStore().user!)) {
		return null;
	}
	return (
		<div>
			{mappingExtraData.map((med, medIndex) => {
				return (
					<div key={medIndex} className="flex">
						{med.type === EExtraDataMappingType.NoEmptyValueNoDefault && (
							<>
								<span className="text-[#ff00ff]">No empty value or default</span>&nbsp; for variable&nbsp;"
								<span className="text-blue-600">{med.element!.value.trim()}"</span>
							</>
						)}
						{med.type === EExtraDataMappingType.NotAllMappingsUsed && (
							<>
								<span className="text-red-600">Not all input used</span>&nbsp; : &nbsp;{" "}
								<span className="text-blue-600">{JSON.stringify(med.mappings!.map((m) => m.word))}</span>
							</>
						)}
						{med.type === EExtraDataMappingType.InputWithNoMapping && (
							<>
								<span className="text-red-600">Input without mapping</span>&nbsp; : &nbsp;{" "}
								<span className="text-blue-600">{JSON.stringify(med.mappings!.map((m) => m.word))}</span>
							</>
						)}
						{!errorsOnly && med.type === EExtraDataMappingType.QuantityModifier && (
							<>
								<span className="text-green-500">QuantityModifier</span>&nbsp; : &nbsp;{" "}
								<span className="text-green-600">
									{JSON.stringify(
										med.mappings?.map(
											(m) => `${m.mapping?.ticInput}:${m.mapping?.quantityType}=${m.mapping?.quantityValue}`,
										),
									)}
								</span>
							</>
						)}
					</div>
				);
			})}
		</div>
	);
}

const EstimateTableRow: React.FC<{
	pageId: string;
	tuple: ITupleOutputForUI;
	tupleIndex: number;
	fullPageImagePath: string;
	getTupleOutputById: (tupleId: string, pageId: string) => ITupleOutputForUI | undefined;
}> = observer(({ pageId, tuple, tupleIndex, fullPageImagePath, getTupleOutputById }) => {
	const [forceQuantityUpdate, setForceQuantityUpdate] = React.useState(0);
	const [forceRecalc, setForceRecalc] = React.useState(0);
	const finalQuantities = React.useRef<string[]>([]);
	const processedEstimateStore = getProcessedEstimatesStore();
	const processedEstimatesStoreDebug = getProcessedEstimatesStoreDebug();
	const currentEstimateStore = getEstimaticsCurrentProjectStore();
	const [showTupleImage, setShowTupleImage] = React.useState(false);
	const [hoverOverConfidence, setHoverOverConfidence] = React.useState(false);
	const firestoreToolsCollectionRef = collection(
		useFirestore(),
		`devLineItemsForQA/${currentEstimateStore.currentEstimateID}/lineItems`,
	) as CollectionReference<any>;
	const lineItemsDataFromDataBase = useFirestoreCollectionData<any>(firestoreToolsCollectionRef, { idField: "tupleId" });
	const [notesOpen, setNotesOpen] = React.useState(false);
	// logDebug('tuple', tuple.originalTupleIndex, tuple.lineItems[0].lineItem, tuple.hasError);
	useEffect(() => {
		setTimeout(() => {
			const textarea = document.getElementById(`${tupleIndex}-t-notes`) as HTMLTextAreaElement;
			if (!textarea) return;
			textarea.scrollTop = textarea.scrollHeight;
		}, 2000);
	}, []);

	useEffect(() => {
		setFinalQuantities();
	}, [currentEstimateStore.measurementDataTracker, forceQuantityUpdate]);

	if (lineItemsDataFromDataBase.status === "loading") {
		return <div>Loading...</div>;
	}

	function setFinalQuantities() {
		function getFinalQuantity(lineItem: ILineItemForUI, pageId: string): string {
			return EngineSharedUtils.getFinalQuantity(lineItem, pageId, (id, measurementType) => {
				return currentEstimateStore.getMeasurementData(id, measurementType);
			});
		}
		const fq = tuple.lineItems
			.filter((li) => !li.deleted) // TODO :: filter out deleted line items in the store's level
			.map((lineItem) => {
				return getFinalQuantity(lineItem, pageId);
			});
		finalQuantities.current = fq;
		setForceRecalc((v) => v + 1);
	}

	function getConfidence(lineItem: ILineItemForUI, tuple: ITupleOutputForUI) {
		function getNumericalConfidence(lineItem: ILineItemForUI): number | null {
			let rightConfidence = null;
			let leftConfidence = null;
			let lowConfidenceArrayValue = null;

			if (lineItem.rightMapping && lineItem.rightMapping.length > 0) {
				rightConfidence = lineItem.rightMapping[0].confidence * 100;
			}

			if (lineItem.leftMapping && lineItem.leftMapping.length > 0) {
				leftConfidence = lineItem.leftMapping[0].confidence * 100;
			}

			if (tuple.lowConfidenceArray && tuple.lowConfidenceArray.length > 0) {
				lowConfidenceArrayValue = Math.min(...tuple.lowConfidenceArray.map((val) => val.confidence * 100));
			}

			const confidenceValues = [rightConfidence, leftConfidence, lowConfidenceArrayValue];
			return confidenceValues.every((val) => val == null)
				? null
				: Math.min(rightConfidence ?? 90, leftConfidence ?? 90, lowConfidenceArrayValue ?? 90);
		}

		if (lineItem.confirmed) {
			return "100%";
		}

		if (EngineSharedUtils.getQuantityStringForLineItem(lineItem, "N/A") === "N/A") {
			return "10%";
		}

		const c = lineItem.confidence;
		if (c != null) {
			if (c > 1) {
				const parentConf = tuple.lineItems[0].confidence;
				if (parentConf != null) {
					return `${(c * parentConf).toFixed(0)}%`;
				}
			}

			return `${(c * 100).toFixed(0)}%`;
		}

		// For complements, return (parent's confidence - 10%)
		if (lineItem.isComplement && !tuple.lineItems[0].isComplement) {
			const parentConfidence: number = parseFloat(getConfidence(tuple.lineItems[0], tuple) ?? "90") ?? 90;
			return `${(parentConfidence - 10).toFixed(0)}%`;
		}

		// If tuple had an error in the past but now doesn't, it was manually resolved.
		if (tuple.hadErrorThatHasBeenFixed === true) {
			return "100%";
		}

		// Line Item with issue that's not a low confidence scan
		const confidence = getNumericalConfidence(lineItem);
		if (tuple.hasError) {
			// If confidence greater than 90, it's most likely a "background problem", so we'll call it N/A for right now.
			if (confidence == null || confidence >= 90) {
				return "0%";
			}
		}

		// Manually added line item
		if (confidence == null) {
			return "100%";
		}

		// Cap Confidence of the handwriting scan at 90%.
		// Gets to 100% by being confirmed or manually editted/added.
		const capOCRConfidence = confidence > 90 ? 90 : confidence < 40 ? 40 : confidence;
		return `${capOCRConfidence.toFixed(0)}%`;
	}

	// TODO :: merge with setMeasurementLikely
	async function setMeasurement(lineItemIndex: number, formula: IQuantityFormula) {
		currentEstimateStore.showLoadingAnimation = true;
		try {
			tuple.lineItems[lineItemIndex].formula = formula;
			// logDebug("setMeasurement", tuple);
			await getProcessedEstimatesStore().updateOrCreateLineItem(
				tuple.tupleId,
				currentEstimateStore.estimaticsData.estimateId,
				pageId,
				tuple,
			);
		} catch (err) {
			logError("setMeasurement", err);
			toastNotify("Error updating the quantity", true);
		}
		currentEstimateStore.showLoadingAnimation = false;
	}

	// here we need to update both the render (tuple passed to the component) tuple and the database tuple ( get from calling getTupleOutputById )
	async function setMeasurementLikely(dbTuple: ITupleOutputForUI, lineItemIndex: number, formula: IQuantityFormula) {
		// logDebug("setMeasurement", dbTuple, tuple, lineItemIndex, EngineSharedUtils.getFormulaString(formula));
		currentEstimateStore.showLoadingAnimation = true;
		try {
			// in likely we have only one line item so use 0 index
			dbTuple.lineItems[0].formula = formula;
			// update the logical tuple with the appropriate index
			tuple.lineItems[lineItemIndex].formula = formula;

			// logDebug("setMeasurement", tuple);
			await getProcessedEstimatesStore().updateOrCreateLineItem(
				dbTuple.tupleId,
				currentEstimateStore.estimaticsData.estimateId,
				pageId,
				dbTuple,
			);
		} catch (err) {
			logError("setMeasurement", err);
			toastNotify("Error updating the quantity", true);
		}
		currentEstimateStore.showLoadingAnimation = false;
	}
	async function toggleShowTupleImage() {
		setShowTupleImage((v) => !v);
	}
	const lineItemsToUse = tuple.lineItems.filter((li) => !li.deleted);
	// logDebug("lineItemsToUse", lineItemsToUse, tuple);
	const shouldBlink =
		getProcessedEstimatesStore().blinkTupleLineIndex === tupleIndex ||
		(tuple.originalTupleIndex && tuple.originalTupleIndex === getProcessedEstimatesStore().blinkTupleLineIndex);
	return (
		<div
			id="EstimateTableRow"
			className={`${
				tuple.hasError || tuple.isFreeFormFlag
					? `w-[98%]  ml-4 my-2 border rounded-xl bg-white flex flex-col`
					: `w-[100%] px-6  border-l border-r ${
							shouldBlink ? "bg-[#FEF0C7]" : tuple.isComplementOf ? "bg-[#F9FAFB]" : "border-b bg-white"
					  }  border-[#eaecf0] flex flex-col`
			}`}
		>
			{lineItemsToUse.map((lineItem, lineItemIndex) => {
				// if (lineItem.addedByTPARule) {
				// 	logDebug("lineItem.addedByTPARule", lineItem);
				// }
				if (tuple.isComplementOf && !tuple.hasError) {
					if (lineItemIndex > 0) {
						return null;
					}
					const parent = getTupleOutputById(tuple.isComplementOf, pageId);
					if (!parent) {
						logDebug("parent not found", tuple.isComplementOf);
						return null;
					}
					// We'll show the recommendations whose parent has an error in the Error Resolution Panel
					if (parent.hasError === true) {
						return null;
					}
					return (
						<div
							key={lineItemIndex}
							className="mt-2 mb-2 rounded-xl flex-col justify-center items-start inline-flex overflow-hidden"
						>
							<div className="self-stretch pr-3 w-full bg-white rounded-2xl border border-[#84caff] justify-start items-center inline-flex overflow-hidden">
								<div className="justify-start w-full items-start gap-2 flex">
									<div className="relative  w-full  pl-5 pr-4 py-2.5 flex-col justify-start items-start gap-2 inline-flex ">
										<div className="h-[17.50px] justify-center items-center gap-2 inline-flex">
											<div className="text-[#0f1728] text-sm font-normal font-['Hanken Grotesk'] leading-tight">
												{parent.lineItems[0].lineItem}
											</div>
										</div>
										{lineItemsToUse.map((lineItem1, lineItemIndex1) => {
											return (
												<div
													className="flex justify-between w-full  h-[20px]"
													key={lineItem1.lineItem + lineItemIndex1}
												>
													<img
														src="/assets/ui/likely-vec.svg"
														className={`absolute left-5 w-5 h-5`}
														style={{
															top: `${(lineItemIndex1 + 1) * 27}px`,
														}}
													/>
													<div className="flex">
														<div className=" w-[332px] justify-start items-center gap-1.5 inline-flex">
															<div className="justify-center items-center gap-5 flex">
																<div className="self-stretch px-0.5 flex-col justify-start items-start gap-2 inline-flex"></div>
																<div className="text-[#0f1728] text-sm font-semibold font-['Hanken Grotesk'] leading-tight">
																	{lineItem1.lineItem}
																</div>
															</div>
														</div>
														<EstimateTableRowElement
															disableScroll={true}
															onContentChange={async (formula) => {
																await setMeasurementLikely(
																	getTupleOutputById(lineItem1.$$complementTupleId!, pageId)!,
																	// lineItem1.$$complementTuple!,
																	lineItemIndex1,
																	formula,
																);
																setFinalQuantities();
															}}
															tid={getTupleOutputById(lineItem1.$$complementTupleId!, pageId)!.tupleId}
															editable={true}
															text={EngineSharedUtils.getQuantityStringForLineItem(lineItem1, "N/A")}
															cls="w-40 no-break h-[18px]"
														/>
														<EstimateTableRowElement
															disableScroll={true}
															key={forceRecalc}
															text={finalQuantities.current[lineItemIndex1]}
															cls="w-40 no-break h-[18px]"
														/>
														<EstimateTableRowElement
															text={getConfidence(lineItem1, parent)}
															cls="w-40 no-break h-[18px] overflow-hidden"
															visualElement={
																getConfidence(lineItem1, parent) == "N/A" ? null : (
																	// Progress bar dependent on the confidence of the line item
																	<div className="w-[50px] h-1.5 bg-gray-200 rounded-full">
																		<div
																			className={`h-full rounded-full ${
																				parseFloat(getConfidence(lineItem1, parent)) >= 85
																					? "bg-green-500"
																					: parseFloat(getConfidence(lineItem1, parent)) >= 65
																					? "bg-yellow-500"
																					: "bg-red-500"
																			}`}
																			style={{
																				width: `${parseFloat(getConfidence(lineItem1, parent))}%`,
																			}}
																		/>
																	</div>
																)
															}
														/>
													</div>
													<div className="grow shrink basis-0 self-stretch justify-end items-center gap-4 flex">
														<div className="justify-end items-center gap-4 flex">
															<div
																onClick={async () => {
																	const realTuple = getTupleOutputById(
																		lineItem1.$$complementTupleId!,
																		pageId,
																	)!;
																	currentEstimateStore.showLoadingAnimation = true;
																	try {
																		realTuple.isComplementOf = "";
																		realTuple.isLikely = false;
																		realTuple.lineItems[0].isComplement = false; // we can leave it true for it to get a star but for now we will remove it
																		realTuple.lineItems[0].confirmed = true;
																		realTuple.lineItems[0].confidence = 1;
																		await getProcessedEstimatesStore().updateOrCreateLineItem(
																			realTuple.tupleId,
																			currentEstimateStore.estimaticsData.estimateId,
																			pageId,
																			realTuple,
																		);
																		toastNotify("Line item added", false);
																	} catch (err) {
																		toastNotify("Error adding the line item", true);
																	}
																	currentEstimateStore.showLoadingAnimation = false;
																}}
																className="px-3.5 py-1 bg-white rounded-lg border border-[#eaecf0] justify-center items-center gap-2 flex overflow-hidden btn"
															>
																<div className="justify-start items-center gap-2 flex ">
																	<div className="text-[#344053] text-sm font-semibold font-['Hanken Grotesk'] leading-tight">
																		Add line item
																	</div>
																</div>
															</div>
														</div>
														<div
															onClick={async () => {
																currentEstimateStore.showLoadingAnimation = true;
																try {
																	const realTuple = getTupleOutputById(
																		lineItem1.$$complementTupleId!,
																		pageId,
																	)!;

																	realTuple.lineItems[0].deleted = true;
																	realTuple.deleted = tuple.lineItems.every((li) => li.deleted);
																	await getProcessedEstimatesStore().updateOrCreateLineItem(
																		realTuple.tupleId,
																		currentEstimateStore.estimaticsData.estimateId,
																		pageId,
																		realTuple,
																	);
																	toastNotify("Recommendation deleted", false);
																} catch (err) {
																	toastNotify("Error deleting the line item", true);
																}
																currentEstimateStore.showLoadingAnimation = false;
															}}
															className="p-1 btn bg-[#d92c20] rounded-lg shadow-[0px_1px_2px_0px_rgba(16,24,40,0.05)] border border-[#d92c20] justify-center items-center gap-2 flex overflow-hidden"
														>
															<img
																src="/assets/ui/trash-01.svg"
																className="w-4 h-4 relative  overflow-hidden"
															/>
														</div>
													</div>
												</div>
											);
										})}
									</div>
								</div>
							</div>
						</div>
					);
				} else {
					const likelyComplementTuples = getLikelyComplementTuples(tuple, pageId);
					const hasErrorAndAtLeastOneComplement =
						tuple.hasError && (tuple.lineItems.some((li) => li.isComplement) || likelyComplementTuples.length > 0);
					if (lineItem.isComplement && tuple.hasError) {
						return null; // don't show complement in error panel. We will show them in error resolution panel
					}
					return (
						<div key={lineItem.lineItem + (-lineItemIndex).toFixed(0)} className={"relative items-center flex h-full"}>
							{(lineItem.isComplement || hasErrorAndAtLeastOneComplement) && !lineItem.addedByTPARule && (
								<img src="/assets/ui/star.svg" className={`absolute ${tuple.hasError ? "left-2" : "-left-2"} w-5 h-5`} />
							)}
							{!lineItem.isComplement && !hasErrorAndAtLeastOneComplement && lineItem.addedByTPARule && (
								<img src="/assets/ui/wrench.svg" className={`absolute ${tuple.hasError ? "left-2" : "-left-2"} w-5 h-5`} />
							)}
							{(lineItem.isComplement || hasErrorAndAtLeastOneComplement) && lineItem.addedByTPARule && (
								<>
									<img
										src="/assets/ui/star.svg"
										className={`absolute ${tuple.hasError ? "left-2" : "-left-2"} w-5 h-5`}
									/>
									<img
										src="/assets/ui/wrench.svg"
										className={`absolute ${tuple.hasError ? "left-8" : "left-4"} w-5 h-5`}
									/>
								</>
							)}
							<div
								className={`w-[100%] justify-start  flex  h-full ${tuple.hasError ? "cursor-pointer" : ""}`}
								onClick={() => {
									if (tuple.hasError) {
										tuple.fullPageImagePath = fullPageImagePath; // TODO :: this need to be set by the backend
										// logDebug('tuple', tuple);
										processedEstimateStore.showErrorResolutionPanelForTuple = { tuple, pageId };
									} else {
										// !processedEstimateStore.showQAPanel && toggleShowTupleImage();
									}
								}}
							>
								<div className={`group justify-between  flex h-full  ${tuple.hasError && " hover:text-[#db6803] w-full"}`}>
									<div className="flex h-full min-h-[70px] ">
										<div className="w-[52px] self-stretch pl-5 justify-start items-center gap-2.5 flex">
											{tuple.hasError ? (
												<>{/* <img src="/assets/ui/trash-02.svg" className="w-5 h-5" /> */}</>
											) : (
												<div className="w-[200px] text-[#0f1728] text-sm font-normal font-['Hanken Grotesk'] leading-tight">
													{tupleIndex + 1}.{lineItemIndex}
												</div>
											)}
										</div>
										<EstimateTableRowElement
											text={lineItem.lineItem}
											cls="w-[300px] pr-4 gap-4 btn "
											onClick={() => {
												logDebug("tuple", tuple);
												logDebug("lineItem", lineItem);
												// processedEstimateStore.showQAPanel &&
												toggleShowTupleImage();
											}}
										/>
										<>
											<EstimateTableRowElement
												onContentChange={async (formula) => {
													await setMeasurement(lineItemIndex, formula);
													setFinalQuantities();
												}}
												tid={tuple.tupleId}
												editable={true}
												text={EngineSharedUtils.getQuantityStringForLineItem(lineItem, "N/A")}
												cls="w-40 no-break "
											/>
											<EstimateTableRowElement
												key={forceRecalc}
												text={finalQuantities.current[lineItemIndex]}
												cls="w-40 no-break"
											/>
											<EstimateTableRowElement
												text={getConfidence(lineItem, tuple)}
												textComponent={
													<div className={`text-sm font-normal font-['Hanken Grotesk'] leading-tight`}>
														{getConfidence(lineItem, tuple)}
													</div>
												}
												cls="w-40 no-break"
												visualElement={
													getConfidence(lineItem, tuple) == "N/A" ? null : (
														// Progress bar dependent on the confidence of the line item
														<div className="w-[50px] h-1.5 bg-gray-200 rounded-full">
															<div
																className={`h-full rounded-full ${
																	parseFloat(getConfidence(lineItem, tuple)) >= 85
																		? "bg-green-500"
																		: parseFloat(getConfidence(lineItem, tuple)) >= 65
																		? "bg-yellow-500"
																		: "bg-red-500"
																}`}
																style={{
																	width: `${parseFloat(getConfidence(lineItem, tuple))}%`,
																}}
															/>
														</div>
													)
												}
											/>
										</>
									</div>
									{tuple.hasError && (
										<div
											className="flex flex-col h-full min-w-64 min-h-16   text-sm  relative"
											onMouseEnter={() => {
												setShowTupleImage(true);
											}}
											onMouseLeave={() => {
												setShowTupleImage(false);
											}}
										>
											{lineItemIndex === 0 &&
												errorTextFromTuple(tuple.lineItems[0].mappingExtraData, tuple.lowConfidenceArray).map(
													(e) => {
														return <div className={showTupleImage ? "opacity-30" : ""}>{e}</div>;
													},
												)}
											{lineItemIndex === 0 && showTupleImage && (
												<div className="absolute top-5 right-0">
													<ImageCanvas
														url={RestAPI.getStorageFileUrl(fullPageImagePath)}
														rect={tuple.tupleRegion}
														paddingPixels={10}
													/>
												</div>
											)}
										</div>
									)}
									{lineItemIndex === 0 && tuple.hasError && tuple.lineItems.length === 1 && (
										<div className="w-64 pt-5 opacity-0 group-hover:opacity-100 transition-opacity duration-100 flex justify-between p-4">
											<LassoSimpleButtonFull
												onClick={async (e) => {
													e.preventDefault();
													e.stopPropagation();
													currentEstimateStore.showLoadingAnimation = true;
													try {
														tuple.lineItems[lineItemIndex].deleted = true;
														tuple.deleted = tuple.lineItems.every((li) => li.deleted);
														try {
															await getProcessedEstimatesStore().updateOrCreateLineItem(
																tuple.tupleId,
																currentEstimateStore.estimaticsData.estimateId,
																pageId,
																tuple,
															);
														} catch (err) {
															logError("discard line item", err);
														}
														logDebug("discard line item", tuple);
														toastNotify("Line item successfully discarded", false);
													} catch (err) {}

													currentEstimateStore.showLoadingAnimation = false;
												}}
												caption="Discard"
												customButtonStyle={{ height: 32, backgroundColor: "#bb0000" }}
											></LassoSimpleButtonFull>
											<LassoSimpleButtonFull
												onClick={async (e) => {
													e.preventDefault();
													e.stopPropagation();
													currentEstimateStore.showLoadingAnimation = true;
													try {
														tuple.hasError = false;
														tuple.hadErrorThatHasBeenFixed = true;
														tuple.lineItems.forEach((li) => {
															li.mappingExtraData = [];
															li.confidence = 1;
														});
														await getProcessedEstimatesStore().updateOrCreateLineItem(
															tuple.tupleId,
															currentEstimateStore.estimaticsData.estimateId,
															pageId,
															{
																...tuple,
																tupleRegion: tuple.tupleRegion,
															},
															"ErrorResolutionPanel",
															{
																left: tuple.originalInput?.left || [],
																right: tuple.originalInput?.right || [],
																selections: tuple.originalInput?.selections || [],
															},
														);
														logDebug("approveLineItem", tuple);
														toastNotify("Line item successfully saved", false);
													} catch (err) {
														logError("approveLineItem", err);
														toastNotify("Error saving the line item", true);
													}
													currentEstimateStore.showLoadingAnimation = false;
												}}
												caption="Confirm"
												customButtonStyle={{ height: 32 }}
											></LassoSimpleButtonFull>
										</div>
									)}
									{lineItemIndex === 0 && tuple.hasError && tuple.lineItems.length > 1 && (
										<div className="w-64 pt-5 opacity-0 group-hover:opacity-100 transition-opacity duration-100 flex justify-between p-4">
											{/* <div className="w-32"></div> */}
											<LassoSimpleButtonFull
												onClick={async (e) => {}}
												caption="Error Resolution Panel"
												customButtonStyle={{ height: 32 }}
											></LassoSimpleButtonFull>
										</div>
									)}
								</div>
							</div>
							<div className="absolute bottom-0 ">
								{processedEstimatesStoreDebug.showQAPanel && getMappingExtraDataContent(lineItem.mappingExtraData)}
							</div>
							{!tuple.hasError && (
								<div className="flex">
									{!tuple.isFreeFormFlag && (
										<button
											className={`check-button mr-2 flex items-center justify-center w-5 h-5 rounded-full border border-[#555] transition-colors duration-300 ${
												lineItem.confirmed ? "bg-[#333]" : "bg-transparent"
											}`}
											onClick={async () => {
												// Don't allow confirmation of a Line Item that has no quantity.
												if (
													(lineItem.confirmed ?? false) === false &&
													EngineSharedUtils.getQuantityStringForLineItem(lineItem, "N/A") === "N/A"
												) {
													toastNotify("Line item must have a quantity to be confirmed", true);
													return;
												}
												const newApprovedState = !lineItem.confirmed;
												lineItem.confirmed = newApprovedState;

												if (lineItem.confirmed === true) {
													toastNotify(`Line item confirmed`, false);
												}

												// It's possible we don't want to do this on every button click... but leaving it for now
												try {
													await getProcessedEstimatesStore().updateOrCreateLineItem(
														tuple.tupleId,
														currentEstimateStore.estimaticsData.estimateId,
														pageId,
														tuple,
													);
												} catch (err) {
													logError("approveLineItem", err);
												}
											}}
										>
											<span
												className={`text-s leading-none ${
													lineItem.confirmed ? "text-white" : "text-[#555]"
												} opacity-${lineItem.confirmed ? "100" : "70"}`}
											>
												✓
											</span>
										</button>
									)}
									<div
										className={`h-full flex items-center btn border rounded mr-2 ${
											tuple.isFreeFormFlag ? "ml-[-100px]" : ""
										}`}
										onClick={() => {
											logDebug("edit line item", tuple, lineItemIndex, tupleIndex, pageId);
											getProcessedEstimatesStore().setEditingLineItemTuple(tuple, lineItemIndex, tupleIndex, pageId);
											getProcessedEstimatesStore().fullPageImagePath = fullPageImagePath;
										}}
									>
										<img src="/assets/ui/edit-04.svg" className="w-5 h-5" />
									</div>
									<div
										className="h-full flex items-center btn"
										onClick={async () => {
											const areYouSure = confirm("Are you sure you want to delete this line item?");
											if (!areYouSure) {
												logDebug("cancel delete", tuple, lineItem);
												return;
											}
											currentEstimateStore.showLoadingAnimation = true;
											// when the user approves the line item, we need to update the iDocumentForUI and remove all the errors currently reported there
											// tuple.deleted = true;
											lineItem.deleted = true;
											// test to see if all line items are deleted
											tuple.deleted = tuple.lineItems.every((li) => li.deleted);
											setForceQuantityUpdate((v) => v + 1);
											try {
												await getProcessedEstimatesStore().updateOrCreateLineItem(
													tuple.tupleId,
													currentEstimateStore.estimaticsData.estimateId,
													pageId,
													tuple,
												);
											} catch (err) {
												logError("approveLineItem", err);
											}
											logDebug("approveLineItem", tuple.tupleId);
											toastNotify("Line item successfully deleted", false);
											currentEstimateStore.showLoadingAnimation = false;
										}}
									>
										<img src="/assets/ui/trash-02.svg" className="w-5 h-5" />
									</div>
								</div>
							)}
						</div>
					);
				}
			})}
			{!tuple.hasError && showTupleImage && (
				<div className="h-full" id="ImagePreview">
					<ImageCanvas
						className={"h-12"}
						url={RestAPI.getStorageFileUrl(fullPageImagePath)}
						rect={tuple.tupleRegion}
						paddingPixels={10}
					/>
				</div>
			)}
		</div>
	);
});
export default EstimateTableRow;
